"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStagedDefaultCompanyPropertyValueForSelectedProperty = exports.getStagedDefaultOwnerPropertyValueForSelectedProperty = exports.getStagedDefaultContactPropertyValueForSelectedProperty = exports.getStagedDefaultOwnerPropertyValues = exports.getStagedDefaultCompanyPropertyValues = exports.getStagedDefaultContactPropertyValues = exports.getStagedDefaultCompanyProperties = exports.getStagedDefaultOwnerProperties = exports.getStagedDefaultContactProperties = exports.getEmailStaging = exports.getUpdateTypeSelectedType = exports.getUpdateTypeModalOpen = exports.getEmailCreationModalData = exports.getEmailCreationModalType = exports.getEmailCreationModalOpen = exports.getUpdateFooterSelectedId = exports.getUpdateFooterModalOpen = exports.getSetBccEmailModalOpen = exports.getResetSmtpTokenPasswordSelectedToken = exports.getResetSmtpTokenPasswordModalOpen = exports.getTypesTableLanguageFilter = exports.getTypesTableFilter = exports.getMostRecentlyCreatedSmtpToken = exports.getMostRecentlyCreatedSmtpTokenId = exports.getMakeFooterDefaultSelectedFooter = exports.getMakeFooterDefaultModalOpen = exports.getDeleteSmtpTokenSelectedName = exports.getDeleteSmtpTokenSelectedId = exports.getDeleteSmtpTokenModalOpen = exports.getDeleteFooterSelectedName = exports.getDeleteFooterSelectedId = exports.getDeleteFooterModalOpen = exports.getCreateSmtpTokenModalOpen = exports.getCreateTypeModalOpen = exports.getCreateFooterModalOpen = void 0;

var _reselect = require("reselect");

var _constants = require("settings-ui-sdk/CanSpamSettings/constants");

var _constants2 = require("settings-ui-sdk/SmtpTokens/constants");

var _selectors = require("settings-ui-sdk/CanSpamSettings/selectors");

var _selectors2 = require("settings-ui-sdk/SmtpTokens/selectors");

var _selectors3 = require("settings-ui-sdk/SubscriptionDefinitions/selectors");

var _interactionsSelectors = require("../../../../website/modules/pages/selectors/interactionsSelectors");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var getInteractions = function getInteractions(state) {
  return state.modules.marketing.email.interactions;
};

var getInteractionsProperty = function getInteractionsProperty(property) {
  return (0, _reselect.createSelector)([getInteractions], function (interactions) {
    return interactions.get(property);
  });
};

var getCreateFooterModalOpen = getInteractionsProperty('createFooterModalOpen');
exports.getCreateFooterModalOpen = getCreateFooterModalOpen;
var getCreateTypeModalOpen = getInteractionsProperty('createTypeModalOpen');
exports.getCreateTypeModalOpen = getCreateTypeModalOpen;
var getCreateSmtpTokenModalOpen = getInteractionsProperty('createSmtpTokenModalOpen');
exports.getCreateSmtpTokenModalOpen = getCreateSmtpTokenModalOpen;
var getDeleteFooterModalOpen = getInteractionsProperty('deleteFooterModalOpen');
exports.getDeleteFooterModalOpen = getDeleteFooterModalOpen;
var getDeleteFooterSelectedId = getInteractionsProperty('deleteFooterSelectedId');
exports.getDeleteFooterSelectedId = getDeleteFooterSelectedId;
var getDeleteFooterSelectedName = (0, _reselect.createSelector)([getDeleteFooterSelectedId, _selectors.getCanSpamSettings], function (id, canSpamSettings) {
  if (canSpamSettings.has(id)) {
    return canSpamSettings.get(id).get(_constants.NAME);
  }

  return null;
});
exports.getDeleteFooterSelectedName = getDeleteFooterSelectedName;
var getDeleteSmtpTokenModalOpen = getInteractionsProperty('deleteSmtpTokenModalOpen');
exports.getDeleteSmtpTokenModalOpen = getDeleteSmtpTokenModalOpen;
var getDeleteSmtpTokenSelectedId = getInteractionsProperty('deleteSmtpTokenSelectedId');
exports.getDeleteSmtpTokenSelectedId = getDeleteSmtpTokenSelectedId;
var getDeleteSmtpTokenSelectedName = (0, _reselect.createSelector)([getDeleteSmtpTokenSelectedId, _selectors2.getSmtpTokens], function (id, smtpTokens) {
  if (smtpTokens.has(id)) {
    return smtpTokens.get(id).get(_constants2.CAMPAIGN_NAME);
  }

  return null;
});
exports.getDeleteSmtpTokenSelectedName = getDeleteSmtpTokenSelectedName;
var getMakeFooterDefaultModalOpen = getInteractionsProperty('makeFooterDefaultModalOpen');
exports.getMakeFooterDefaultModalOpen = getMakeFooterDefaultModalOpen;
var getMakeFooterDefaultSelectedId = getInteractionsProperty('makeFooterDefaultSelectedId');
var getMakeFooterDefaultSelectedFooter = (0, _reselect.createSelector)([getMakeFooterDefaultSelectedId, _selectors.getCanSpamSettings], function (id, canSpamSettings) {
  return canSpamSettings.get(id);
});
exports.getMakeFooterDefaultSelectedFooter = getMakeFooterDefaultSelectedFooter;
var getMostRecentlyCreatedSmtpTokenId = getInteractionsProperty('mostRecentlyCreatedSmtpTokenId');
exports.getMostRecentlyCreatedSmtpTokenId = getMostRecentlyCreatedSmtpTokenId;
var getMostRecentlyCreatedSmtpToken = (0, _reselect.createSelector)([getMostRecentlyCreatedSmtpTokenId, _selectors2.getSmtpTokens], function (id, smtpTokens) {
  return smtpTokens.get(id);
});
exports.getMostRecentlyCreatedSmtpToken = getMostRecentlyCreatedSmtpToken;
var getTypesTableFilter = getInteractionsProperty('typesTableFilter');
exports.getTypesTableFilter = getTypesTableFilter;
var getTypesTableLanguageFilter = getInteractionsProperty('typesTableLanguageFilter');
exports.getTypesTableLanguageFilter = getTypesTableLanguageFilter;
var getResetSmtpTokenPasswordModalOpen = getInteractionsProperty('resetSmtpTokenPasswordModalOpen');
exports.getResetSmtpTokenPasswordModalOpen = getResetSmtpTokenPasswordModalOpen;
var getResetSmtpTokenPasswordSelectedId = getInteractionsProperty('resetSmtpTokenPasswordSelectedId');
var getResetSmtpTokenPasswordSelectedToken = (0, _reselect.createSelector)([getResetSmtpTokenPasswordSelectedId, _selectors2.getSmtpTokens], function (id, smtpTokens) {
  return smtpTokens.get(id);
});
exports.getResetSmtpTokenPasswordSelectedToken = getResetSmtpTokenPasswordSelectedToken;
var getSetBccEmailModalOpen = getInteractionsProperty('setBccEmailModalOpen');
exports.getSetBccEmailModalOpen = getSetBccEmailModalOpen;
var getUpdateFooterModalOpen = getInteractionsProperty('updateFooterModalOpen');
exports.getUpdateFooterModalOpen = getUpdateFooterModalOpen;
var getUpdateFooterSelectedId = getInteractionsProperty('updateFooterSelectedId');
exports.getUpdateFooterSelectedId = getUpdateFooterSelectedId;
var getEmailCreationModalOpen = getInteractionsProperty('emailCreationModalOpen');
exports.getEmailCreationModalOpen = getEmailCreationModalOpen;
var getEmailCreationModalType = getInteractionsProperty('emailCreationModalType');
exports.getEmailCreationModalType = getEmailCreationModalType;
var getEmailCreationModalData = getInteractionsProperty('emailCreationModalData');
exports.getEmailCreationModalData = getEmailCreationModalData;
var getUpdateTypeModalOpen = getInteractionsProperty('updateTypeModalOpen');
exports.getUpdateTypeModalOpen = getUpdateTypeModalOpen;
var getUpdateTypeSelectedId = getInteractionsProperty('updateTypeSelectedId');
var getUpdateTypeSelectedType = (0, _reselect.createSelector)([getUpdateTypeSelectedId, _selectors3.getSubscriptionDefinitions], function (id, definitions) {
  if (definitions.has(id)) {
    return definitions.get(id).toJS();
  }

  return {};
});
exports.getUpdateTypeSelectedType = getUpdateTypeSelectedType;

var getEmailStaging = function getEmailStaging(state) {
  return state.modules.marketing.email.staging;
};

exports.getEmailStaging = getEmailStaging;
var getStagedDefaultContactProperties = (0, _reselect.createSelector)([getEmailStaging], function (staging) {
  return staging.defaultContactProperties;
});
exports.getStagedDefaultContactProperties = getStagedDefaultContactProperties;
var getStagedDefaultOwnerProperties = (0, _reselect.createSelector)([getEmailStaging], function (staging) {
  return staging.defaultOwnerProperties;
});
exports.getStagedDefaultOwnerProperties = getStagedDefaultOwnerProperties;
var getStagedDefaultCompanyProperties = (0, _reselect.createSelector)([getEmailStaging], function (staging) {
  return staging.defaultCompanyProperties;
});
exports.getStagedDefaultCompanyProperties = getStagedDefaultCompanyProperties;
var getStagedDefaultContactPropertyValues = (0, _reselect.createSelector)([getStagedDefaultContactProperties], function (properties) {
  return properties.get('staged');
});
exports.getStagedDefaultContactPropertyValues = getStagedDefaultContactPropertyValues;
var getStagedDefaultCompanyPropertyValues = (0, _reselect.createSelector)([getStagedDefaultCompanyProperties], function (properties) {
  return properties.get('staged');
});
exports.getStagedDefaultCompanyPropertyValues = getStagedDefaultCompanyPropertyValues;
var getStagedDefaultOwnerPropertyValues = (0, _reselect.createSelector)([getStagedDefaultOwnerProperties], function (properties) {
  return properties.get('staged');
});
exports.getStagedDefaultOwnerPropertyValues = getStagedDefaultOwnerPropertyValues;
var getStagedDefaultContactPropertyValueForSelectedProperty = (0, _reselect.createSelector)([getStagedDefaultContactProperties, _interactionsSelectors.getSelectedProperty], function (propertyValues, selectedProperty) {
  return propertyValues.getIn(['staged', _UrlPathParams.ALL_DOMAINS, selectedProperty]) || '';
});
exports.getStagedDefaultContactPropertyValueForSelectedProperty = getStagedDefaultContactPropertyValueForSelectedProperty;
var getStagedDefaultOwnerPropertyValueForSelectedProperty = (0, _reselect.createSelector)([getStagedDefaultOwnerProperties, _interactionsSelectors.getSelectedProperty], function (propertyValues, selectedProperty) {
  return propertyValues.getIn(['staged', _UrlPathParams.ALL_DOMAINS, selectedProperty]) || '';
});
exports.getStagedDefaultOwnerPropertyValueForSelectedProperty = getStagedDefaultOwnerPropertyValueForSelectedProperty;
var getStagedDefaultCompanyPropertyValueForSelectedProperty = (0, _reselect.createSelector)([getStagedDefaultCompanyProperties, _interactionsSelectors.getSelectedProperty], function (propertyValues, selectedProperty) {
  return propertyValues.getIn(['staged', _UrlPathParams.ALL_DOMAINS, selectedProperty]) || '';
});
exports.getStagedDefaultCompanyPropertyValueForSelectedProperty = getStagedDefaultCompanyPropertyValueForSelectedProperty;